module.exports = __webpack_public_path__ + "img/loading.73277d4d.svg";